import { useInitializeChat } from "@/hooks";
import { authProvider, ResourceName } from "@/utils";
import { Box } from "@mui/material";
import { FC, PropsWithChildren, useEffect } from "react";
import {
  Title,
  useNotify,
  useRedirect,
  useResourceDefinitionContext,
} from "react-admin";

type CustomRouteLayoutProps = PropsWithChildren & {
  title: string;
  resource: ResourceName;
};

const CustomRouteLayout: FC<CustomRouteLayoutProps> = ({
  children,
  title,
  resource,
}) => {
  useInitializeChat();

  const notify = useNotify();
  const redirect = useRedirect();
  const { register } = useResourceDefinitionContext();

  useEffect(() => {
    if (!authProvider.canAccess) return;
    authProvider
      .canAccess({ action: "custom-page", resource })
      .then((hasAccess) => {
        if (!hasAccess) {
          notify("Access denied", { type: "warning" });
          redirect("/");
        }
      });
    register({ name: resource });
  }, []);

  return (
    <>
      <Title title={title} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          padding: "12px",
        }}
      >
        {children}
      </Box>
    </>
  );
};

export { CustomRouteLayout };
